<div id="filter-card">
  <dxo-card>
    <div class="header-container">
      <h2 class="card-body-header" data-e2e="MemberCardHeader">Filter employees</h2>
      <div (click)="clearFilters()" (keydown)="clearFilters()" class="link">Reset filters</div>
    </div>
    <card-body>
      <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <div class="data-containter">
          <div class="row-input">
            <dxo-text-input
              label="Employee name"
              maxlength="80"
              class="employeeName"
              formControlName="employeeName"
              (valueChange)="employeeName$.next($event)"
            ></dxo-text-input>

            <dxo-dropdown
              data-e2e="Status_dropdown"
              label="Status"
              class="statusdropdown"
              [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '' } }]"
              (valueChange)="onFilterChange($any($event), 'status')"
              [optionsObjects]="StatusOptions"
              [value]="searchParameter.status"
            ></dxo-dropdown>

            <dxo-dropdown
              data-e2e="BillGroupNumber_dropdown"
              label="Bill division"
              class="billlocationdropdown"
              [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '' } }]"
              (valueChange)="onFilterChange($any($event), 'billingDivision')"
              [optionsObjects]="billLocationOptions"
              [value]="searchParameter.billingDivision"
            ></dxo-dropdown>
          </div>
        </div>
      </form>
    </card-body>
  </dxo-card>
</div>

<div id="list-card">
  <dxo-card>
    <div class="header-container">
      <h2 class="card-body-header" data-e2e="MemberListCardHeader">Employee list</h2>
    </div>
    <div class="loader-container">
      <dxo-circular-loader *ngIf="isLoading" [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
    </div>
    <card-body *ngIf="members$ | async as members">
      <dxo-data-table
        [headers]="tableHeaders"
        [items]="members.listMember"
        [showCardViewWhenMobile]="true"
        [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '' } }]"
      >
        <ng-template dxoHeaderKey="employeeName">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('LastName')"
            (keypress)="onClickTableHeader('LastName')"
          >
            Employee name
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'LastName'
              "
              [color]="searchParameter.sortField === 'LastName' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              sort
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoHeaderKey="status">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('Status')"
            (keypress)="onClickTableHeader('Status')"
          >
            Status
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'Status'
              "
              [color]="searchParameter.sortField === 'Status' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
              >sort
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoHeaderKey="billingDivision">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('BillingDivision')"
            (keypress)="onClickTableHeader('BillingDivision')"
          >
            Bill division
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'BillingDivision'
              "
              [color]="searchParameter.sortField === 'BillingDivision' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              sort
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoKey="employeeName" let-item>
          <span class="row-cell">
            <dxo-button
              [textButton]="true"
              [text]="item.lastName + ', ' + item.firstName"
              (handleClick)="goDetail(item.employeeId, item.contractId, item.lastName, item.middleName, item.firstName)"
            >
            </dxo-button>
          </span>
          <span class="row-cell1">({{ item.dob }})</span>
        </ng-template>

        <ng-template dxoKey="billDivision" let-item>
          <span class="list-cell">{{ item.billingDivision }}</span>
        </ng-template>

        <ng-template dxoKey="status" let-item>
          <span class="row-cell">
            <span class="status-indicator" [style.background-color]="item.indicator"></span>
            {{ item.status }}
          </span>
        </ng-template>
      </dxo-data-table>

      <div class="paginator">
        <dxo-server-pagination
          [itemCount]="members.totalResults"
          [currentPage]="searchParameter.page"
          [pageSize]="searchParameter.pageSize"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
        ></dxo-server-pagination>
      </div>
    </card-body>
  </dxo-card>
</div>
